import styled from 'styled-components'

export const TextInputWrapper = styled.div`
    position: relative;
`

export const CancelManualEntryButton = styled.button`
    position: absolute;
    top: 34px;
    right: 8px;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
`

export const ManualEntryButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.brand.primary};
    font-size: inherit;
    white-space: nowrap;
`
